import React, { useContext, useState } from "react";
import Graphview from "../../../pages/ComplaintTat/ComplaintStats/Graphview";
import Header from "../../../components/Header/HeaderTat";
import Header2 from "../../../components/Header/Header";
import Footer from "../../../components/Footer/Footer";
import { FilterContext } from "../../../context/Filter";
import WaterMark from "../../../components/WaterMark";

const CompIndex = () => {
  const [totalSsoData, setSsoData] = useState(null);
  const [selectedSearchType, setSelectedSearchType] = useState("");
  const [initialLoad, setInitialLoad] = useState(true);
  const [resetTrigger, setResetTrigger] = useState(false);

  const {
    setIstoggle,
    setSearchData,
    setComplaintButtonName,
  } = useContext(FilterContext);

  const handleReset = () => {
    // console.log("Reset button clicked");
    setSsoData(null);
    setSelectedSearchType("");
    setInitialLoad(true);
    setIstoggle(false);
    setSearchData([]);
    setResetTrigger(prev => !prev);

    if (setComplaintButtonName) {
      setComplaintButtonName("totalComplaints");
    }
  };

  return (
    <div>
      <WaterMark />
      <Header2 heading={"Complaint TAT Summary"} />

      <div className="mt-4">
        {/* 🔹 pass reset handler */}
        <Header onReset={handleReset} />

        <div className="flex flex-col gap-2 m-2 mt-4">
          <Graphview
            totalSsoData={totalSsoData}
            setSsoData={setSsoData}
            selectedSearchType={selectedSearchType}
            setSelectedSearchType={setSelectedSearchType}
            initialLoad={initialLoad}
            setInitialLoad={setInitialLoad}
            resetTrigger={resetTrigger}
          />
        </div>

        <Footer />
      </div>
    </div>
  );
};

export default CompIndex;
